import React from "react";
import "./style.css";
export const AboutCSIT = () => {
  return (
    <div className="container">
      <div className="about-page">
        <h2>About CSIT</h2>
      </div>
    </div>
  );
};
